import { render, staticRenderFns } from "./UIHeaderBar.vue?vue&type=template&id=1b89b52b"
import script from "./UIHeaderBar.vue?vue&type=script&lang=ts"
export * from "./UIHeaderBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports